// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'Folder Created Successfully': 'تم إضافة مجلد بنجاح',
  'Kindly Add an Image/Video': 'برجاء إضافة صورة او فيديو ',
  'Sorry, This Folder have Data Inside, Please Delete and Retry':
    'عذرا، هذا المجلد يحتوي على بيانات داخله ، يرجى حذف وإعادة المحاولة',
  'The folder has been deleted successfully': 'تم حذف الملف بنجاح',
  'The folder has been modified successfully': 'تم تعديل الملف بنجاح',
};
